<template>
    <div>
        <div class="header" :class="{ 'scrolled': scrolled }" :style="{ background: (isBule || scrolled) ? '#fff' : 'transparent' }">
            <img v-if="isBule || scrolled" src="../assets/images/LOGO (1).png" alt="logo" class="logo" @click="$router.push('/')">
            <img v-else src="../assets/images/LOGO.png" alt="logo" class="logo" @click="$router.push('/')">
            <div class="navs" :class="{ 'mobile-menu-open': mobileMenuOpen }" @click.stop>
                <div class="nav" v-for="nav in navs" :key="nav.path" @click="closeMobileMenu(nav)"
                    :style="{ color: (isBule || scrolled) ? '#2c3441' : '#fff' }">
                    <span @click="$router.push(nav.path)">{{ nav.name }}</span>
                </div>
                <div v-if="!userInfo.realname" class="login-btn" :class="(isBule || scrolled) ? 'isBule' : ''"
                    @click="$router.push('/login')">
                    <div :style="{ 'color': (isBule || scrolled) ? '#2c3441' : '#fff' }">
                        <i class="el-icon-user-solid" style="font-size:16px"></i>
                        &nbsp; &nbsp;登录
                    </div>
                </div>
                <el-dropdown v-else>
                    <span class="el-dropdown-link" style="color: #004a8c;">{{ userInfo.realname }}<i
                            class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <div v-if="roles.length">
                            <el-dropdown-item>
                                <div @click="$router.push('/me')" :class="{ 'activeText': $route.path == '/me' }">认证信息管理
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <el-popover placement="top" trigger="click">
                                    <div class="flex_between dropdown" v-for="(item, index) in roles" :key="index"
                                        :class="{ 'active_role': !index }">
                                        <div>{{ item.name }}</div>
                                        <span v-if="!index" class="current_role">当前身份</span>
                                        <el-link v-else type="danger" @click="changeRole(item)"
                                            :loading="loading">切换</el-link>
                                    </div>
                                    <div slot="reference">认证信息切换</div>
                                </el-popover>
                            </el-dropdown-item>
                        </div>
                        <div v-else>
                            <el-dropdown-item>
                                <div @click="$router.push({ path: '/sign-up', query: { type: 'add' } })">账号认证</div>
                            </el-dropdown-item>
                        </div>
                        <el-dropdown-item>
                            <div @click="$router.push('/order')">我的订单</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="changePassword">修改密码</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div @click="quit">退出登录</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="mobile-menu-toggle" @click="toggleMobileMenu" :style="{ color: (isBule || scrolled) ? '#2c3441' : '#fff' }">
                <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-menu'"></i>
            </div>

        </div>
        <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" :width="dialogWidth" :close-on-click-modal="false"
            @close="resetPasswordForm">
            <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="100px"
                class="password-form">
                <el-form-item label="原密码" prop="oldPassword">
                    <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码（6-20位字母或数字）"
                        show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码"
                        show-password clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="passwordDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="passwordLoading" @click="submitPasswordChange">确定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
export default {
    props: ['isBule'],
    data() {
        // 验证确认密码
        const validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入新密码'))
            } else if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入的密码不一致'))
            } else {
                callback()
            }
        }

        return {
            navs: [{ name: '首页', path: '/' },
            //  { name: '服务产品', path: '/product' }, 
            { name: '关于我们', path: '/#about' }, { name: '加入我们', path: '/join' }, { name: '联系我们', path: '/#contactUs', }],
            roles: [],
            userInfo: { list: [] },
            loading: false,
            mobileMenuOpen: false,
            passwordDialogVisible: false,
            passwordLoading: false,
            showJoinUsHover: false,
            joinUsHideTimer: null,
            scrolled: false,
            passwordForm: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            passwordRules: {
                oldPassword: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9]{6,20}$/, message: '密码需为6-20位字母或数字', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, validator: validateConfirmPassword, trigger: 'blur' }
                ]
            },
            dialogWidth: '500px'
        }
    },
    mounted() {
        window.addEventListener('localStorageChange', this.handleCustomStorageChange);
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
        // 只在用户已登录时调用认证信息接口
        if (this.userInfo.realname) {
            this.axios.get(this.$url.getCertificationInformation).then(res => {
                this.roles = res.data
                console.log(this.roles);
            }).catch(() => {
                // 捕获错误但不影响页面渲染
                this.roles = []
            })
        }
        // 点击外部关闭移动端菜单
        document.addEventListener('click', this.handleClickOutside)
        // 设置对话框响应式宽度
        this.updateDialogWidth()
        window.addEventListener('resize', this.updateDialogWidth)
        // 监听页面滚动，切换导航栏背景
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
        window.removeEventListener('resize', this.updateDialogWidth)
        window.removeEventListener('scroll', this.handleScroll)
        // 确保恢复 body 滚动
        document.body.style.overflow = ''
        // 清理定时器
        if (this.joinUsHideTimer) {
            clearTimeout(this.joinUsHideTimer)
            this.joinUsHideTimer = null
        }
    },
    methods: {
        changePassword() {
            this.passwordDialogVisible = true
        },
        // 重置密码表单
        resetPasswordForm() {
            this.$refs.passwordForm && this.$refs.passwordForm.resetFields()
            this.passwordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            }
        },
        // 提交密码修改
        submitPasswordChange() {
            this.$refs.passwordForm.validate((valid) => {
                if (valid) {
                    this.passwordLoading = true
                    const apiUrl = this.$url.changePassword

                    const params = {
                        oldPwd: this.passwordForm.oldPassword,
                        newPwd: this.passwordForm.newPassword
                    }

                    this.axios.post(apiUrl, params).then(res => {
                        if (res.code == 200) {
                            this.$message.success('密码修改成功，请重新登录')
                            this.passwordDialogVisible = false
                            // 延迟退出登录，让用户看到成功提示
                            setTimeout(() => {
                                this.quit()
                            }, 1500)
                        } else {
                            this.$message.error(res.message || '密码修改失败')
                        }
                    }).catch(err => {
                        this.$message.error(err.message || '密码修改失败，请稍后再试')
                    }).finally(() => {
                        this.passwordLoading = false
                    })
                } else {
                    return false
                }
            })
        },
        // 滚动处理，控制导航栏背景
        handleScroll() {
            this.scrolled = window.scrollY > 50
        },
        // 更新对话框宽度
        updateDialogWidth() {
            if (window.innerWidth <= 768) {
                this.dialogWidth = '90%'
            } else if (window.innerWidth <= 1024) {
                this.dialogWidth = '450px'
            } else {
                this.dialogWidth = '500px'
            }
        },
        changeRole(item) {
            this.loading = true
            this.axios.get(this.$url.changeAccount + '?switchingCustomerId=' + item.customerId).then(res => {
                if (res.code == 200) {
                    this.axios.get(this.$url.getCertificationInformation).then(res => {
                        if (res.data?.length) {
                            // this.roles = res.data
                            localStorage.setItem('roles', res.data.list)
                            window.location.reload()
                        }

                    })
                }
            }).catch(err => {
                this.$message.error(err.message)
            }).finally(() => { this.loading = false })
        },
        quit() {
            localStorage.clear()
            window.location.reload()
        },
        handleCustomStorageChange(event) {
            console.log('登录获取信息', event.value);
            if (event.value) {
                this.userInfo = event.value
                this.roles = this.userInfo.list || []
            }
        },
        toggleMobileMenu(e) {
            e.stopPropagation()
            this.mobileMenuOpen = !this.mobileMenuOpen
            // 防止菜单打开时背景滚动
            if (this.mobileMenuOpen) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
        },
        closeMobileMenu(nav) {
            this.mobileMenuOpen = false
            document.body.style.overflow = ''
        },
        handleJoinUsEnter() {
            // 清除隐藏定时器
            if (this.joinUsHideTimer) {
                clearTimeout(this.joinUsHideTimer)
                this.joinUsHideTimer = null
            }
            // 显示浮层
            this.showJoinUsHover = true
        },
        handleJoinUsLeave() {
            // 延迟隐藏，给用户时间移动鼠标到浮层
            this.joinUsHideTimer = setTimeout(() => {
                this.showJoinUsHover = false
                this.joinUsHideTimer = null
            }, 200)
        },
        handleJoinUsClick() {
            this.showJoinUsHover = false
            if (this.joinUsHideTimer) {
                clearTimeout(this.joinUsHideTimer)
                this.joinUsHideTimer = null
            }
            this.$router.push('/join')
        },
        handleClickOutside(e) {
            if (this.mobileMenuOpen && window.innerWidth <= 768) {
                const header = this.$el
                const navs = header.querySelector('.navs')
                const toggle = header.querySelector('.mobile-menu-toggle')

                if (navs && toggle && !navs.contains(e.target) && !toggle.contains(e.target)) {
                    this.closeMobileMenu()
                }
            }
        }
    }
}
</script>

<style scoped>
.header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, .4);
    padding: 20px 100px 20px 192px;
    white-space: nowrap;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    height: 80px;
    z-index: 999;
    justify-content: space-between;
    transition: background 0.3s ease, box-shadow 0.3s ease;
}

.header.scrolled {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    border-bottom-color: rgba(44, 52, 65, 0.1);
}

.logo {
    width: 289px;
    max-width: 100%;
    /* margin-right: 497px; */
    cursor: pointer;
    flex-shrink: 0;
}

.navs {
    /* flex: 1; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 36px;
}

.nav {
    white-space: nowrap;
    position: relative;
}

.nav span:hover {
    font-weight: 500;
    cursor: pointer;
    color: #004a8c !important;
}

/* 加入我们悬浮浮层 */
.join-us-nav {
    position: relative;
}

.join-us-popover {
    position: fixed;
    top: 80px;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
    pointer-events: none;
    display: flex;
}

.join-us-popover.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
}

.popover-content {
    padding: 48px;
    /* max-width: 1200px; */
    margin: 0 auto;
    width: 50%;
    height: 456px;
    text-align: center;
    color:#2c3441;
    position: relative;
}

.popover-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 64px;
}

.popover-text {
    font-size: 20px;
    max-width: 480px;
    white-space: pre-wrap;
    margin: 0 auto;
    line-height: 36px;
}

.popover-footer {
    text-align: center;
}

.popover-btn {
    background: #004a8c;
    color: #fff;
    border: none;
    padding: 10px 32px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.3s ease;
    position: absolute;
    bottom: 64px;
    left: 50%;
    transform: translateX(-50%);
}

.popover-btn:hover {
    background: #003d73;
}

.login-btn {
    display: flex;
    border-radius: 18px;
    height: 36px;
    box-sizing: border-box;
    padding: 8px 20px 6px;
    border: 1px solid #fff;
    margin-left: 64px;
    cursor: pointer;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
}

.isBule {
    border-color: rgba(44, 52, 65, .2);
    color: #333333;
}

.active_role {
    background: #f2f9ff;
    color: #004a8c;
    border-radius: 8px;
}

.dropdown {
    padding: 12px 24px;
    font-size: 16px;
    top: 0;
}

.current_role {
    font-size: 14px;
    padding: 5px 10px;
    margin-left: 10px;
    border: 1px solid rgba(0, 74, 140, 1);
}

.activeText {
    color: #004a8c;
}

.mobile-menu-toggle {
    display: none;
    font-size: 24px;
    cursor: pointer;
    padding: 8px;
    flex-shrink: 0;
}

/* 平板适配 */
/* @media (max-width: 1024px) {
    .header {
        padding: 20px 40px 20px 60px;
    }

    .logo {
        width: 200px;
        margin-right: 40px;
    }

    .navs {
        gap: 16px;
    }

    .login-btn {
        margin-left: 24px;
        padding: 8px 16px 6px;

    }
} */

/* 移动端适配 */
/* @media (max-width: 768px) {
    .header {
        padding: 16px 20px;
        height: auto;
        min-height: 60px;
        position: absolute;
    }

    .logo {
        width: 120px;
        margin-right: 0;
    }

    .mobile-menu-toggle {
        display: block;
    }

    .navs {
        position: fixed;
        top: 60px;
        left: 0;
        right: 0;
        background: #fff;
        flex-direction: column;
        align-items: stretch;
        padding: 0 20px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease, padding 0.3s ease;
        gap: 0;
        z-index: 1000;
    }

    .navs.mobile-menu-open {
        max-height: 600px;
        padding: 20px;
        overflow-y: auto;
    }

    .nav {
        width: 100%;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;
    }

    .nav:last-of-type {
        border-bottom: 1px solid #f0f0f0;
    }

    .nav span {
        color: #2c3441 !important;
        display: block;
        width: 100%;
        font-size: 16px;
    }

    .nav a {
        text-decoration: none;
    }

    .join-us-popover {
        display: none;
    }

    .login-btn {
        margin-left: 0;
        margin-top: 16px;
        width: 100%;
        justify-content: center;
        border-color: rgba(44, 52, 65, .2);
        color: #333333;
    }

    .login-btn>div {
        color: #111 !important;
    }

    .el-dropdown {
        width: 100%;
        margin-top: 16px;
    }

    .el-dropdown-link {
        display: block;
        width: 100%;
        padding: 12px 0;
        color: #2c3441 !important;
    }
} */

/* 小屏幕手机 */
/* @media (max-width: 480px) {
    .header {
        padding: 12px 16px;
        min-height: 56px;
    }

    .logo {
        width: 100px;
    }

    .navs {
        top: 56px;
    }
} */

/* 修改密码对话框样式 */
.password-form {
    padding: 20px 0;
}

::v-deep .el-dialog__body {
    padding: 20px 20px 10px;
}

::v-deep .el-form-item__label {
    color: #2c3441;
    font-weight: 500;
}

::v-deep .el-input__inner {
    border-radius: 4px;
}

.dialog-footer {
    text-align: right;
    padding-top: 10px;
}

/* @media (max-width: 768px) {
    .password-form {
        padding: 10px 0;
    }

    ::v-deep .el-form-item {
        margin-bottom: 20px;
    }

    ::v-deep .el-dialog__body {
        padding: 15px 15px 5px;
    }
} */
</style>